import style from "./Plans.module.css";
import ChoosePlan from "@/features/auth/components/choosePlan/ChoosePlan";
import Container from "@/layouts/container/Container";
import { usePageTitle } from "@/i18n/usePageTitle";

function Plans() {
	usePageTitle("seo:titles.plans");

	return (
		<div className={style.page}>
			<Container size="mini">
				<ChoosePlan />
			</Container>
		</div>
	);
}

export default Plans;
